const navigateIfChanged = (router, currentPath, route) => {
  if (route === currentPath) return false;

  return router.push(route).catch((error) => {
    if (error && error.name === "NavigationDuplicated") return false;
    throw error;
  });
};

const navigateOrRefresh = (router, currentPath, route, refresh) => {
  if (route === currentPath) {
    refresh();
    return false;
  }

  return navigateIfChanged(router, currentPath, route);
};

const suppressNavigationDuplicated = (Router) => {
  const prototype = Router.prototype;
  ["push", "replace"].forEach((method) => {
    const navigate = prototype[method];
    if (navigate._suppressesNavigationDuplicated) return;

    const wrappedNavigate = function () {
      const result = navigate.apply(this, arguments);
      if (!result || typeof result.catch !== "function") return result;

      return result.catch((error) => {
        if (error && error.name === "NavigationDuplicated") return false;
        throw error;
      });
    };
    wrappedNavigate._suppressesNavigationDuplicated = true;
    prototype[method] = wrappedNavigate;
  });
};

module.exports = {
  navigateIfChanged,
  navigateOrRefresh,
  suppressNavigationDuplicated,
};



// WEBPACK FOOTER //
// ./src/util/routerNavigation.js